// extracted by mini-css-extract-plugin
export default {"ContactInfo":"style_ContactInfo__eyKJI","container":"style_container__7W25G","contactItem":"style_contactItem__+zZal","image":"style_image__st3Ab","content":"style_content__IUARK"};